'use client';

// TODO use the ones from @types and expose properly
declare global {
  interface Window {
    /** Google Tag Manager */
    dataLayer: Record<string, any>[] | any[];
    /** Google Analytics */
    gtag: (...args: any[]) => void;
  }
}

/**
 * Google Analytics gtag function
 * @see https://developers.google.com/analytics/devguides/collection/gtagjs
 */
export function gtag(..._args: unknown[]) {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

/**
 * Identify user in Google Analytics
 * @see https://developers.google.com/analytics/devguides/collection/ga4/user-id
 */
export const gtagIdentify = (data: {
  user_id: string;
  email?: string;
  phonenumber?: string;
}) => {
  window.dataLayer.push(data);
};
